import keyMirror from 'keymirror';

const recoverAccountErrors = keyMirror({
  'ERR.UC.RECOVERACCOUNT.INVALID_REQUEST': null,
  'ERR.UB.RECOVERACCOUNT.INVALID_EMAIL': null,
  'ERR.UB.RECOVERACCOUNT.INVALID_BIRTHDATE': null,
  'ERR.UB.RECOVERACCOUNT.FIND_MEMBER_ERROR': null,
  'ERR.UB.RECOVERACCOUNT.CRIS_TIMEOUT': null,
  'ERR.UC.RECOVERACCOUNT.NOTIFICATION_SERVICE_NOTAVAILABLE': null,
  'ERR.UC.RECOVERACCOUNT.EMAIL_SEND_FAILED': null,
  'ERR.UC.RECOVERACCOUNT.BASE_RECOVERACCOUNT_SERVICE_NOTAVAILABLE': null,
  'ERR.UC.PROFILE.PING_ID_ERROR': null,
});

export const recoverAccountTypeErrors = [
  recoverAccountErrors['ERR.UB.RECOVERACCOUNT.INVALID_EMAIL'],
  recoverAccountErrors['ERR.UB.RECOVERACCOUNT.INVALID_BIRTHDATE'],
  recoverAccountErrors['ERR.UB.RECOVERACCOUNT.FIND_MEMBER_ERROR'],
];

export const recoverAccountMicroTypeErrors = [
  recoverAccountErrors['ERR.UB.RECOVERACCOUNT.CRIS_TIMEOUT'],
  recoverAccountErrors['ERR.UC.RECOVERACCOUNT.NOTIFICATION_SERVICE_NOTAVAILABLE'],
  recoverAccountErrors['ERR.UC.RECOVERACCOUNT.EMAIL_SEND_FAILED'],
  recoverAccountErrors['ERR.UC.RECOVERACCOUNT.BASE_RECOVERACCOUNT_SERVICE_NOTAVAILABLE'],
  recoverAccountErrors['ERR.UC.PROFILE.PING_ID_ERROR'],
];